export default __webpack_public_path__ + "static/media/vg-logo-image.b71c24d6.png";